export class User {
	userId: number;
    name: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    password: string;
    confirmPassword: string;
    fullName: string;
    phoneNumber: string;
    companyName: string;
    title: string;
    mediaId: number;
}



// WEBPACK FOOTER //
// ./src/app/classes/user.ts